// src/App.js
import React, { useEffect } from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { StoreProvider } from '../contexts/StoreContext';
import { HomePreferencesProvider } from '../contexts/HomePreferencesContext';
import { AuthProvider } from '../contexts/AuthContext';
import { ProductsProvider } from '../contexts/ProductsContext';
import { FavoritesProvider } from '../contexts/FavoritesContext';
import { CartProvider } from '../contexts/CartContext';
import { BannersProvider } from '../contexts/BannersContext';
import { SocialMediaProvider } from '../contexts/SocialMediaContext';
import { DisplayPreferencesProvider, useDisplayPreferences } from '../contexts/DisplayPreferencesContext';

import NavigationBar from './NavigationBar';
import CatalogView from './CatalogView';
import ProductDetail from './ProductDetail';
import StoreDetail from './StoreDetail';
import GalleryPage from './GalleryPage';
import Footer from './Footer';
import CategoryDetail from './CategoryDetail';
import ProfileView from './ProfileView';
import CartView from './CartView';
import FavoritesView from './FavoritesView';
import OrdersView from './OrdersView';
import LandingPage from './LandingPage';
import FastQuotePage from './FastQuotePage';
import PortfolioPage from './PortfolioPage';
import FAQView from './FAQView';
import MaintenanceView from './MaintenanceView';

function ConditionalContactRoute() {
  const { showContact } = useDisplayPreferences();
  if (!showContact) return <Navigate to="/" replace />;
  return <StoreDetail />;
}

function ConditionalFAQRoute() {
  const { showFAQ } = useDisplayPreferences();
  if (!showFAQ) return <Navigate to="/" replace />;
  return <FAQView />;
}

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function AppContent() {
  const { isUnderMaintenance, maintenanceMessage } = useDisplayPreferences();

  if (isUnderMaintenance) {
    return <MaintenanceView message={maintenanceMessage} />;
  }

  return (
    <div
      style={{
        padding: '0px',
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh',
      }}
    >
      <ScrollToTop />
      <NavigationBar />
      <div style={{ flex: 1 }}>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="welcome" element={<FastQuotePage />} />
          <Route path="products" element={<CatalogView />} />
          <Route path="product/:id" element={<ProductDetail />} />
          <Route path="category/:id" element={<CategoryDetail />} />
          <Route path="contact" element={<ConditionalContactRoute />} />
          <Route path="browse" element={<GalleryPage />} />
          <Route path="ourwork" element={<PortfolioPage />} />
          <Route path="cart" element={<CartView />} />
          <Route path="faq" element={<ConditionalFAQRoute />} />
          <Route path="favorites" element={<FavoritesView />} />
          <Route path="orders" element={<OrdersView />} />
          <Route path="profile" element={<ProfileView />} />
        </Routes>
      </div>
      <Footer />
    </div>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <ProductsProvider>
        <FavoritesProvider>
          <CartProvider>
            <StoreProvider>
              <HomePreferencesProvider>
              <BannersProvider>
              <SocialMediaProvider>
              <DisplayPreferencesProvider>
              <AppContent />
              </DisplayPreferencesProvider>
              </SocialMediaProvider>
              </BannersProvider>
              </HomePreferencesProvider>
            </StoreProvider>
          </CartProvider>
        </FavoritesProvider>
      </ProductsProvider>
    </AuthProvider>
  );
}
